import { Injectable } from "@angular/core";
import { ClientService } from "../services/client.service";
import { ArrayClientRepository } from "./abstract/array.client.repository";
import { ViolationCode } from "../types/Violation/ViolationCode";

@Injectable({
  providedIn: "root",
})
export class IrefItemCodeRepository extends ArrayClientRepository<ViolationCode> {
  constructor(clientService: ClientService) {
    super(clientService, "schemas.schCFG_IREF_Item_Code.records", "codeID");
  }
}
